import { useEffect, useState } from "react";

import { Box, Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { assignmentApi } from "../../../services/assets/asset-assignment";
import { AssetAssignmentRejectionLog } from "../../../config/types";
import useAppNavigation from "../../../hooks/useAppNavigation";
import { MainPageBase } from "../../page-bases/MainPageBase";
import LabelButton from "../../../components/Button/LabelButton";
import appRoutePath from "../../../config/path";
import SimpleLabel from "../../../components/Label";
import CustomAccordion from "../../../components/custom-accordion";

function AssignmentRejectionDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [data, setDate] = useState<AssetAssignmentRejectionLog>();

  const fetchData = async () => {
    const res = await assignmentApi.getRejectedAssignmentById(id ?? "");
    if (res.data) {
      setDate(res.data);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useAppNavigation();

  if (!data) {
    return null;
  }
  return (
    <MainPageBase
      pageState={"main"}
      title={`Asset Rejection Information`}
      extraComponent={
        <LabelButton
          onPress={() =>
            navigate({
              path: appRoutePath.REJECTED_INBOUND_ASSET_ASSIGNEMENT_PAGE,
            })
          }
          label={"Back"}
          direction={"left"}
        />
      }
    >
      <Box height={`100%`} display={"flex"} justifyContent={"center"}>
        <Stack width={"100%"}>
          <Stack spacing={1.5} marginBottom={2} direction={"column"}>
            <Stack mb={3} spacing={2}>
              <Stack spacing={1}>
                <SimpleLabel title="Asset Information" />
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Brand Name" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.asset_brand}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Model Name" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.asset_model}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel
                    title="Asset Embossment Number"
                    fontWeight={400}
                  />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.asset_embossment_number}
                    width={"100%"}
                  />
                </Stack>
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Asset Serial Number" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.asset_serial_number}
                    width={"100%"}
                  />
                </Stack>
              </Stack>

              <Stack spacing={1}>
                <SimpleLabel title="Assigned User Details" />
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Full Name" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.user_first_name + " " + data?.user_last_name}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Email" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.user_email}
                    width={"100%"}
                  />
                </Stack>

                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Telephone" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.user_telephone}
                    width={"100%"}
                  />
                </Stack>
              </Stack>

              <Stack>
                <SimpleLabel title="Extra Information" />
                <Stack direction={"row"} width={"100%"}>
                  <SimpleLabel title="Date Recorded" fontWeight={400} />
                  <SimpleLabel
                    fontWeight={700}
                    title={data?.created_at}
                    width={"100%"}
                  />
                </Stack>
              </Stack>

              <CustomAccordion
                title="Rejection reason"
                info={data?.reason ?? ""}
              />
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </MainPageBase>
  );
}

export { AssignmentRejectionDetailPage };
